import _ from 'lodash';
import React from 'react';

import BooleanIcon from 'components/BooleanIcon';
import {INITIAL_BILLING_FREQUENCY} from 'ducks/bookings/detail';

import './styles.css';

export interface BookingFormInfoSectionProps {
  className?: string;
  initialRoomTypeName: string;
  isAffordable?: boolean;
  isStudent?: boolean;
  stripePaymentId: string;
  initialBillingFrequency: string;
  salesAgent: string;
  referralCode: string;
  initialRoomPrice: number;
  originalLengthOfStay: string;
  floorPreference: string;
  initialBillingWithGuarantor: boolean;
  securityDepositWeeks: number;
}

const formatBooleanValue = (value?: boolean) => (
  <React.Fragment>
    {value === true && 'True'}
    {value === false && 'False'}
    {value === null && 'N/A'}
  </React.Fragment>
);

const BookingFormInfoSection: React.SFC<BookingFormInfoSectionProps> = ({
  initialRoomTypeName,
  isAffordable,
  isStudent,
  stripePaymentId,
  initialBillingFrequency,
  salesAgent,
  referralCode,
  initialRoomPrice,
  originalLengthOfStay,
  floorPreference,
  initialBillingWithGuarantor,
  securityDepositWeeks
}) => (
  <div className="BookingFormInfoSection colab-sidepadding-2">
    <div>
      Original Room Type:{' '}
      <div className="BookingFormInfoSection__infoText">
        {initialRoomTypeName}
      </div>
    </div>
    <div>
      Affordable:{' '}
      <div className="BookingFormInfoSection__infoText">
        {formatBooleanValue(isAffordable)}
      </div>
    </div>
    <div>
      Student:{' '}
      <div className="BookingFormInfoSection__infoText">
        {formatBooleanValue(isStudent)}
      </div>
    </div>
    <div>
      Payment plan:{' '}
      <div className="BookingFormInfoSection__infoText">
        {_.get(
          INITIAL_BILLING_FREQUENCY,
          initialBillingFrequency,
          initialBillingFrequency
        )}
      </div>
    </div>
    <div>
      Sales agent:{' '}
      <div className="BookingFormInfoSection__infoText">{salesAgent}</div>
    </div>
    <div>
      Referral code:{' '}
      <div className="BookingFormInfoSection__infoText">{referralCode}</div>
    </div>
    <div>
      Room price:{' '}
      <div className="BookingFormInfoSection__infoText">{initialRoomPrice}</div>
    </div>
    <div>
      Original length of stay:{' '}
      <div className="BookingFormInfoSection__infoText">
        {originalLengthOfStay}
      </div>
    </div>
    <div>
      Stripe ID:{' '}
      <div className="BookingFormInfoSection__infoText">{stripePaymentId}</div>
    </div>
    <div>
      Floor Preference:{' '}
      <div className="BookingFormInfoSection__infoText">{floorPreference}</div>
    </div>
    <div>
      With guarantor:{' '}
      <div className="BookingFormInfoSection__infoText">
        <BooleanIcon value={initialBillingWithGuarantor} />
      </div>
    </div>
    <div>
      Deposit weeks:{' '}
      <div className="BookingFormInfoSection__infoText">
        {securityDepositWeeks}
      </div>
    </div>
  </div>
);

export default BookingFormInfoSection;
